import { CheckInStatusEnum } from 'app/shared/enums/check-in-status-type.enum';
import { AgencyStoreDto } from 'app/shared/models/agency-store.model';
import { AgencyDto } from 'app/shared/models/agency.model';
import { ActiveChannelDTO, ChannelDTO } from 'app/shared/models/channel.model';
import { Shop } from 'app/shared/models/shop.model';

import { BasicSchema } from '../common/basic-schema.model';
import { AgencyListItemVM } from '../salesNetwork/agency.model';
import { TierVM } from '../settings/tier.model';
import { PointOfSaleDetailVM } from './bo-point-of-sale.model';
import { GridSchema } from '../common/grid-schema.model';

export interface GridStorePointOfSaleSchema<T> extends GridSchema<T> {
  customerId?: number | null;
  storeId?: number | null;
  pointOfSaleId?: number | null;
  tierId?: number | null;
  checkInStatus?: number | null;
}

export class OnlineStoreVM {
  isPresentOnDB: boolean;
  isEnabled: boolean;
  tierId: number;
  agencies: AgencyListItemVM[];
  channels: ChannelDTO[];
  store: Shop;
  storeName: string;
  storeId: number;
  checkInStatus: CheckInStatusEnum;
  checkInMessage: string;
  agencyStoreIds?: number[];
  channelIds?: number[];
  tiersData?: BasicSchema<TierVM>;
  agencyData?: AgencyListItemVM[];
  agencySelectPage?: number;
  agencyNextData?: AgencyListItemVM[];
  constructor(init?: Partial<OnlineStoreVM>) {
    Object.assign(this, init);
  }
}

export interface OnlineStoreDto {
  tierId: number;
  agencies: AgencyDto[];
  agencyStoreAssociations: AgencyStoreDto[];
  store: Shop;
  storeName: string;
  checkInStatus: CheckInStatusEnum;
  checkInMessage: string;
}

export class StorePointOfSaleVM {
  storeId: number;
  pointOfSaleId: number;
  tierId?: number;
  checkInStatus: CheckInStatusEnum;
  checkInMessage: string;
  storeName: string;
  pointOfSaleName: string;
  pointOfSaleAddress: string;
  customerName: string;
  checked: boolean;
  constructor(init?: Partial<StorePointOfSaleVM>) {
    Object.assign(this, init);
  }
}

export class StorePointOfSaleInputModel {
  checkInStatus?: CheckInStatusEnum;
  customerId?: number;
  tierId?: number;
  pointOfSaleId?: number;
  searchString?: string;
  maxResultCount?: number;
  sorting?: string;
  skipCount?: number;
}

export class StoreCustomerLocationGetDto {
  store: Shop;
  checkInStatus: CheckInStatusEnum;
  checkInMessage: string;

  constructor(init?: StoreCustomerLocationGetDto) {
    Object.assign(this, init);
  }
}
